import React from "react";
import {useTranslation} from "react-i18next";
import {DateTimeFormatter} from "../../common/DateTimeFormatter";
import {Stack} from "@mui/material";
import {UserDto} from "../../client/user/User";
import {UserTranslKey} from "./UserTranslKey";
import {RobSubscriptionStatusFormatter} from "../person/RobSubscriptionStatusFormatter";
import {PersonDataOriginFormatter} from "../person/PersonDataOriginFormatter";
import {DetailsTable} from "../../common/details/DetailsTable";
import {DetailsTextRow} from "../../common/details/DetailsTextRow";
import {PersonTranslKey} from "../person/PersonTranslKey";

export interface UserDetailPanelProps {
    user: UserDto;
}

export default function UserBasicDetailPanel(props: Readonly<UserDetailPanelProps>) {
    const {user} = props;

    const {t} = useTranslation();
    const validFrom = DateTimeFormatter.formatDateTime(user.validityInterval?.validFrom);
    const validTo = DateTimeFormatter.formatDateTime(user.validityInterval?.validTo);
    const robUpdatedAt = DateTimeFormatter.formatDateTime(user.person?.robUpdatedAt);

    return (
        <Stack>
            <DetailsTable header={t(UserTranslKey.CONTACT_DETAILS)}>
                <DetailsTextRow label={t(UserTranslKey.FIRST_NAME)} value={user.person?.firstName}/>
                <DetailsTextRow label={t(UserTranslKey.LAST_NAME)} value={user.person?.lastName}/>
                <DetailsTextRow label={t(UserTranslKey.EMAIL)} value={user.person?.email}/>
                <DetailsTextRow label={t(UserTranslKey.PHONE)} value={user.person?.phone}/>
                <DetailsTextRow label={t(UserTranslKey.LOGIN)} value={user.login}/>
                <DetailsTextRow label={t(UserTranslKey.DATABOX)} value={user.person?.databox}/>
            </DetailsTable>

            <DetailsTable header={t(UserTranslKey.VALIDITY)}>
                <DetailsTextRow label={t(UserTranslKey.VALID_FROM)} value={validFrom ?? undefined}/>
                <DetailsTextRow label={t(UserTranslKey.VALID_TO)} value={validTo ?? undefined}/>
            </DetailsTable>

            <DetailsTable header={t(UserTranslKey.OTHERS)}>
                <DetailsTextRow label={t(PersonTranslKey.PERSON_DATA_ORIGIN)}
                                value={PersonDataOriginFormatter.formatDataOrigin(user.person?.dataOrigin, t)}/>
                <DetailsTextRow label={t(UserTranslKey.ROB_SUBSCRIPTION_STATUS)}
                                value={RobSubscriptionStatusFormatter.formatSubscriptionStatus(user.person?.subscriptionStatus, t)}/>
                <DetailsTextRow label={t(UserTranslKey.UPDATED_AT_IN_ROB)} value={robUpdatedAt ?? undefined}/>
            </DetailsTable>
        </Stack>
    );
}
